// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "backend/v1/messages.proto" (package "backend.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "../../core/v1/date";
/**
 * @generated from protobuf message backend.v1.GenerateProductKeysRequest
 */
export interface GenerateProductKeysRequest {
    /**
     * @generated from protobuf field: int32 num_keys = 1;
     */
    numKeys: number;
}
/**
 * @generated from protobuf message backend.v1.CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * @generated from protobuf field: string timezone = 1;
     */
    timezone: string;
}
/**
 * PUT /api/user/employer: the optional "employer code or product key" in Settings. A product key links
 * the user to the key's company; otherwise company_name records the employer. Both empty = independent.
 *
 * @generated from protobuf message backend.v1.UpdateUserEmployerRequest
 */
export interface UpdateUserEmployerRequest {
    /**
     * @generated from protobuf field: string product_key = 1;
     */
    productKey: string;
    /**
     * @generated from protobuf field: string company_name = 2;
     */
    companyName: string;
}
/**
 * @generated from protobuf message backend.v1.MakeAdminRequest
 */
export interface MakeAdminRequest {
    /**
     * @generated from protobuf field: string email = 1;
     */
    email: string;
}
/**
 * @generated from protobuf message backend.v1.UpdateUserCurrentDateRequest
 */
export interface UpdateUserCurrentDateRequest {
    /**
     * @generated from protobuf field: core.v1.Date current_date = 1;
     */
    currentDate?: Date;
}
// @generated message type with reflection information, may provide speed optimized methods
class GenerateProductKeysRequest$Type extends MessageType<GenerateProductKeysRequest> {
    constructor() {
        super("backend.v1.GenerateProductKeysRequest", [
            { no: 1, name: "num_keys", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.GenerateProductKeysRequest
 */
export const GenerateProductKeysRequest = new GenerateProductKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserRequest$Type extends MessageType<CreateUserRequest> {
    constructor() {
        super("backend.v1.CreateUserRequest", [
            { no: 1, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.CreateUserRequest
 */
export const CreateUserRequest = new CreateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserEmployerRequest$Type extends MessageType<UpdateUserEmployerRequest> {
    constructor() {
        super("backend.v1.UpdateUserEmployerRequest", [
            { no: 1, name: "product_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.UpdateUserEmployerRequest
 */
export const UpdateUserEmployerRequest = new UpdateUserEmployerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MakeAdminRequest$Type extends MessageType<MakeAdminRequest> {
    constructor() {
        super("backend.v1.MakeAdminRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.MakeAdminRequest
 */
export const MakeAdminRequest = new MakeAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUserCurrentDateRequest$Type extends MessageType<UpdateUserCurrentDateRequest> {
    constructor() {
        super("backend.v1.UpdateUserCurrentDateRequest", [
            { no: 1, name: "current_date", kind: "message", T: () => Date }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message backend.v1.UpdateUserCurrentDateRequest
 */
export const UpdateUserCurrentDateRequest = new UpdateUserCurrentDateRequest$Type();
